import { Route, Routes, useLocation } from 'react-router-dom';
import { ModalRoutePath, routeConfig } from '../config/routeConfig'
import { PrivacyPolicyModalWrapper } from '../../../../widgets/PrivacyPolicyModal/ui/PrivacyPolicyModalWrapper/PrivacyPolicyModalWrapper';


const AppRouter = () => {
  const location = useLocation();
  const background = location.state?.background;
  const modalIsOpen = location.pathname === ModalRoutePath.privacy_policy;

  return (
    <>
        {/* страницы */}
        <Routes location={background || location}>
            {Object.values(routeConfig).map(route => (
            <Route
                key={route.path}
                path={route.path}
                element={route.element}
            />
            ))}
        </Routes>

        {/* модалки */}
        <PrivacyPolicyModalWrapper isOpen={modalIsOpen} />
    </>
  );
};

export default AppRouter;
